import { Component } from 'react';
import { inject, PropTypes } from 'mobx-react';
import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

// TODO: import stencil components: se-icon

class _ConfirmRemove extends Component {
  onAccept = () => {
    this.props.confirmStore.handleAccept();
  };

  onCancel = () => {
    this.props.confirmStore.handleCancel();
  };

  onClickOutside = (event) => {
    if (event.target !== event.currentTarget) {
      return;
    }

    this.onCancel();
  };

  render() {
    // eslint-disable-next-line camelcase
    const { removeLabel, commonCancelLabel } = this.props.labelsStore;

    return (
      <div className="cart-dialog__overlay" onClick={this.onClickOutside}>
        <div className="cart-dialog__dialog">

          <button type="button" className="button-less cart-dialog__close" onClick={this.onCancel}>
            <PesIcon class="cart-dialog__close-figure" size={pesIconSizes.SMALL}>
              action_delete_cross
            </PesIcon>
          </button>

          <p className="cart-dialog__message">
            <span className="cart-dialog__text">{this.props.confirmStore.contentText}</span>
          </p>

          <div className="cart-dialog__controls">
            <button type="button" className="cart-dialog__btn cart-dialog__btn-secondary" onClick={this.onCancel}>
              {commonCancelLabel}
            </button>
            <button type="button" className="cart-dialog__btn cart-dialog__btn-primary btn-primary" onClick={this.onAccept}>
              {removeLabel}
            </button>
          </div>

        </div>
      </div>
    );
  }
}

_ConfirmRemove.propTypes = {
  labelsStore: propTypes.shape({
    removeLabel: propTypes.string.isRequired,
    commonCancelLabel: propTypes.string.isRequired
  }).isRequired,

  confirmStore: propTypes.shape({
    handleCancel: propTypes.func,
    handleAccept: propTypes.func,
    contentText: propTypes.string
  }).isRequired
};

export const ConfirmRemove = inject('labelsStore', 'confirmStore')(_ConfirmRemove);
